import type { TourDef } from './index';

const a = (id: string): string => `[data-tour="${id}"]`;

export const goalsTour: TourDef = {
  id: 'goals',
  steps: [
    { element: a('goals-new'), popover: { title: 'Start a goal', description: 'Templates cover the common ones. Add a when-then plan; it makes follow-through far more likely.' } },
    { element: a('goals-grid'), popover: { title: 'Progress at a glance', description: 'Rings fill as you go, with your projected date and the next milestone.' } },
  ],
};
